module.exports = __webpack_public_path__ + "img/company-honor-VOC-20241218.a9278bda.jpg";